import {TranslationUnit} from "platform/translation/TranslationUnit";
import Parameter from "platform/util/Parameter";

export interface PopupsReduxState {
    popups: Popup[];
}

export enum PopupType {
    INFO, CONFIRM, ERROR, SUCCESS
}

export enum PopupActionType {
    OK, CANCEL
}

export enum PopupIconType {
    SUCCESS = "success",
    ERROR = "error",
    CONFIRM = "confirm",
    INFO = "info",
}

export interface PopupAction {
    type: PopupActionType;
    text?: TranslationUnit;
    action?: () => void;
    parameters?: Parameter[];
}

export interface Popup {
    id?: number;
    remoteId?: number;
    type: PopupType;
    icon?: PopupIconType;
    title?: TranslationUnit;
    message?: TranslationUnit;
    hyperlink?: string;
    parameters?: Parameter[];
    actions?: PopupAction[];
    showClose?: boolean;
    showButtons?: boolean;
}
